import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { UserSidebar } from './UserSidebar';

interface AppHeaderProps {
  title?: React.ReactNode;
  onBack?: () => void;
}

const AppHeader = ({ title, onBack }: AppHeaderProps) => {
  const navigation = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <header className="flex items-center justify-between px-6 py-4 bg-card border-b border-border gap-3">
      <div className="flex items-center gap-1 min-w-0">
        {onBack && (
          <Button variant="ghost" size="icon" onClick={onBack} className="shrink-0 -ml-2">
            <ArrowLeft className="w-5 h-5" />
          </Button>
        )}
        <h1
          className={`text-xl font-bold text-foreground truncate ${title ? '' : 'cursor-pointer'}`}
          onClick={title ? undefined : () => navigation('/')}
        >
          {title ?? t('warehouse_hub')}
        </h1>
      </div>

      <div className="flex items-center space-x-3">
        {user && (
          <>
            <Button
              variant="ghost"
              className="relative h-10 w-10 rounded-full"
              onClick={() => setSidebarOpen(true)}
            >
              <Avatar className="h-10 w-10">
                <AvatarFallback className="bg-primary text-primary-foreground">{user.initials}</AvatarFallback>
              </Avatar>
            </Button>
            <UserSidebar open={sidebarOpen} onOpenChange={setSidebarOpen} />
          </>
        )}
      </div>
    </header>
  );
};

export default AppHeader;
